export enum CartUrlSortField {
  soldTo = "soldTo"
}
import { ChangeOrderTab } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import { createOrderUrl, shoppingCart } from "@saleor/createOrder/urls";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export enum ExportPiSortField {
  remain_quantity = "remain_quantity",
  total_quantity = "total_quantity",
  price_per_unit = "price_per_unit"
}
export enum ShoppingCartSortField {
  solde_to = "solde_to"
}
export enum ExporPiListSortField {
  piNo = "piNo"
}
export enum ExportOrderSortField {
  material_code = "material_code",
  item_no = "item_no"
}
export enum CartDetailSortField {
  remain_quantity = "remain_quantity",
  total_quantity = "total_quantity",
  price_per_unit = "price_per_unit"
}

export type ExportPiUrlSort = Sort<ExportPiSortField>;
export type ShoppingCartUrlSort = Sort<ShoppingCartSortField>;

export type ExportPiQueryParams = Pagination & ExportPiUrlSort;
export type ShoppingCartQueryParams = Pagination & ShoppingCartUrlSort;

export type ExporPiListUrlSort = Sort<ExporPiListSortField>;
export type ExporPiListUrlQueryParams = Pagination & ExporPiListUrlSort;

export const exporPiListUrl = (params?: ExporPiListUrlQueryParams) =>
  createOrderUrl + "?" + stringifyQs(params);

export const shoppingCartListUrl = (params?: ShoppingCartQueryParams) =>
  shoppingCart + "?" + stringifyQs(params);

export type ExportOrderUrlSort = Sort<ExportOrderSortField>;

export type CartDetailUrlSort = Sort<CartDetailSortField>;

export type ExportOrderQueryParams = Pagination &
  ExportOrderUrlSort & {
    tab: ChangeOrderTab;
    mode: "add" | "edit" | "view";
    enabledCreate?: string;
  };
export type CartDetailUrlQueryParams = Pagination & CartDetailUrlSort;
export const shoppingCartDetailUrl = (url, params?: ShoppingCartQueryParams) =>
  url + "?" + stringifyQs(params);
